import React, { useEffect, useState } from 'react';
import klalog from '../Assets/R.png';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';
import { GetQuickLinks, GetSocialMediaLinks } from '../Services/allApi';

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 500,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
};

function Footer() {
    const [file, setFile] = useState(null);
    const [open, setOpen] = useState(false);
    const [quickLinks, setQuickLinks] = useState([]);
    const [socilaMediaLinks, setSocilaMediaLinks] = useState([]);

    const handleOpen = () => setOpen(true);
    const handleClose = () => {
        setFile(null);
        setOpen(false);
    };

    const handleUploadScreenshot = (e) => {
        const selectedFile = e.target.files[0];
        setFile(selectedFile);

        if (selectedFile) {
            const reader = new FileReader();
            reader.onload = (e) => {
                const imgElement = document.getElementById('screenshotImage');
                if (imgElement) {
                    imgElement.src = e.target.result;
                }
            };
            reader.readAsDataURL(selectedFile);
        }
    };

    useEffect(() => {
        fetchQuickLinks()
        fetchSocialMediaLinks()
    }, []);

    const fetchQuickLinks = async () => {
        try {
            const res = await GetQuickLinks(); // Assuming this API returns an array of links
            setQuickLinks(res?.data?.data); // Assuming res is an array of link objects
            console.log(res);
            
        } catch (error) {
            console.error('Error fetching quick links:', error);
        }
    };

    const fetchSocialMediaLinks = async () => {
        try {
            const res = await GetSocialMediaLinks(); // Assuming this API returns an array of links
            setSocilaMediaLinks(res?.data?.data); // Assuming res is an array of link objects
            console.log(res);
            
        } catch (error) {
            console.error('Error fetching quick links:', error);
        }
    };

    return (
        <>
            <div className='flex flex-col' style={{ height: '100%', width: '100%', fontFamily: "Ropa Sans", backgroundColor: '#D3D3D3' }}>
                <div className='flex lg:flex-row flex-col '>
                    {/* Logo */}
                    <div className='lg:w-3/12 12/12 flex flex-col mt-10 sm:mb-2 mb-0 border-r me-4'>
                        <div className='flex justify-center'>
                            <img src={klalog} alt="" style={{ width: '65%', height: '85%' }} />
                        </div>
                        <div className='flex justify-center'><h1 className='font-bold text-xl mt-2'>Kerala Legislative Assembly</h1></div>
                        <div className='flex justify-center'><h1 className='font-semibold text-md mt-3 text-slate-600'>കേരള നിയമസഭ</h1></div>
                    </div>

                    {/* Quick Links */}
                    <div className='flex flex-col gap-2 w-full '>
                        <div className='flex w-full flex-col sm:mb-0 '>
                            <div className='flex justify-start'><h2 className='font-semibold text-xl sm:mt-10 mt-6 sm:ms-0 ms-5'>Quick Links</h2></div>
                            <div className='flex flex-row justify-start w-full mt-4 flex-wrap '>
                                {
                                    quickLinks?.length > 0 ? (
                                        quickLinks.map((link, index) => (
                                            <div key={index} className='flex flex-col md:w-3/12 w-5/12 md:ps-0 ps-1'>
                                                <li className='mt-4'>
                                                    <u>
                                                        <a href={link.url} target='_blank' className='hover:text-blue-700 overflow-x-hidden md:text-md text-sm' rel="noopener noreferrer">
                                                            {link.text}
                                                        </a>
                                                    </u>
                                                </li>
                                            </div>
                                        ))
                                    ) : (
                                        <div className='text-red-500'>No Quick Links Available</div>
                                    )
                                }
                            </div>
                        </div>

                        {/* Social media links */}
                       {socilaMediaLinks?.length>0&& <div className='flex w-full flex-col sm:mb-0 '>
                            <div className='flex justify-start'><h2 className='font-semibold text-xl sm:mt-10 mt-6 sm:ms-0 ms-5'>Social Media Links</h2></div>
                            <div className='flex flex-row md:justify-start justify-start w-full mt-4 flex-wrap'>
                                {/* Social Media Sections */}
                                {/* Example */}
                                {
                                    setSocilaMediaLinks?.length>0?(
                                        socilaMediaLinks?.map((link,item)=>(
                                            <div className='flex flex-col md:w-3/12 w-5/12 my-2 md:ps-0 ps-2 '>
                                    <p className='overflow-x-hidden'>{link?.text}</p>
                                    <div className='flex flex-row md:gap-10 gap-1'>
                                        <a href={link?.fb} target='_blank' className='text-gray-900 hover:text-blue-800' ><i className="fa-brands fa-facebook text-xl"></i></a>
                                        <a href={link?.yt} target='_blank' className='text-gray-900 hover:text-red-700'><i className="fa-brands fa-youtube text-xl"></i></a>
                                        <a href={link?.x} target='_blank' className='text-gray-900 hover:text-black' ><i className="fa-brands fa-x-twitter text-xl"></i></a>
                                    </div>
                                </div>
                                        ))
                                    ):''
                                }
                               
                            </div>
                        </div>}
                    </div>
                </div>

                <hr className='mt-4 mb-4' />
                {/* IHRD logo */}
                <div className='flex sm:flex-row flex-col sm:justify-center justify-around ' style={{ height: '100%', width: '100%' }}>
                    <div className='mt-3 sm:mb-5 mb-3 justify-center flex'>
                        {/* <h3 className='text-center text-sm sm:me-2 me-0'>Designed, Developed and Hosted by Production & Maintenance Division IHRD</h3> */}
                        <h3 className='text-center text-sm sm:me-2 me-0'>This site is Maintained by IT Section Kerala Legislative Assembly, Designed and Developed by PMD IHRD</h3>
                    </div>
                    <div className='sm:mb-0 mb-5 justify-center flex'>
                        <a target='_blank' rel="noopener noreferrer" href="http://14.139.189.75/">
                            <img src="https://ihrdadmissions.org/assets/img/ihrdlogorx.png" alt="" style={{ width: '40px', height: '30px' }} />
                        </a>
                    </div>
                </div>
            </div>
        </>
    );
}

export default Footer;
